import { render, staticRenderFns } from "./CustomGroupHeader.vue?vue&type=template&id=5abb490f&"
import script from "./CustomGroupHeader.vue?vue&type=script&lang=js&"
export * from "./CustomGroupHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports